import React from 'react';

import './AboutBlock.css';
import sign_img from '../assets/sign.png';
import GlassyButton from "./GlassyButton";

const AboutBlock = () => {

    const handleClick = () => {
        const username = "obmenvpermi";
        const url = `https://t.me/${username}`;

        window.location.href = url;

        if (window.Telegram?.WebApp?.openTelegramLink) {
            window.Telegram.WebApp.openTelegramLink(url);
        }
    };

    return (
        <div className={'about-wrapper card'}>

            <div className={'about-container'}>

                <div className={'about-sign-container'}>
                    <img className={'about-sign'} src={sign_img} alt="Sign"/>
                </div>

                <h2 className={'uppercase'} style={{marginTop: '2px', marginBottom: '5px'}}>
                    CashCoin — Обмен криптовалют в перми
                </h2>

                <p className={'opacity75'}>
                    Мы осуществляем обмен криптовалют за наличный и безналичный расчет в Перми. Сделки проводим в специально- оборудованном офисе, что гарантирует безопасность и комфорт для наших клиентов.
                </p>

                <p className={'opacity75'} style={{marginTop: '10px'}}>
                    Курс фиксируется заранее в диалоге с оператором. Обмен происходит строго в конфиденциальной обстановке.
                </p>


                <div className={'about-contacts'}>

                    <a href="https://maps.app.goo.gl/covkbZtwHTHjJKea7">
                        <h4 className={'normal uppercase black'}>Адрес: <span
                            className={'bold'}>ул. Луначарского, 90</span></h4>
                    </a>

                    <a href="https://maps.app.goo.gl/covkbZtwHTHjJKea7">
                        <h4 className={'normal uppercase black'}>Часы Работы: <span
                            className={'bold'}>11:00-00:00</span></h4>
                    </a>

                    <a href="tel:+79194946782">
                        <h4 className={'normal uppercase black'}>Телефон: <span
                            className={'bold'}>+7 919 494 67 82</span></h4>
                    </a>

                </div>


                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2113.9998057120715!2d56.22238557751415!3d58.00477147400015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x43e8c73aa59383cf%3A0xbf4fb57f2082faf0!2z0YPQuy4g0JvRg9C90LDRh9Cw0YDRgdC60L7Qs9C-LCA5MCwg0J_QtdGA0LzRjCwg0J_QtdGA0LzRgdC60LjQuSDQutGA0LDQuSwg0KDQvtGB0YHQuNGPLCA2MTQwNjg!5e0!3m2!1sru!2shk!4v1762495862912!5m2!1sru!2shk"
                    className={'about-map'} allowFullScreen="" loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>


                <GlassyButton onClick={() => handleClick()} className={'full'}>
                    Связаться с нами
                </GlassyButton>


            </div>



        </div>
    );
};

export default AboutBlock;